// 任务中心的打开入口（决策 D205）：任务中心挂在顶栏，页面建了后台任务（如消息导出）后用 useTaskCenter 打开它看进度。
import { createContext, useContext } from "react";

/** 任务中心对页面暴露的操作。 */
export interface TaskCenterApi { open: () => void }

export const TaskCenterCtx = createContext<TaskCenterApi>({ open: () => undefined });

/** 打开顶栏的任务中心；页面不在应用外壳里（单测直接渲染页面）时什么也不做。 */
export function useTaskCenter(): TaskCenterApi {
  return useContext(TaskCenterCtx);
}
